// The one Better Auth client (tanstack-router-structure-guide.md → Tiers): the portal and
// features/staff use it. Same origin as the API, so the session cookie rides along. The
// twoFactor plugin is for staff (TOTP is mandatory there) and for owners who enable it.
import { inferAdditionalFields, twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  basePath: "/api/auth",
  // Looked up per request, so tests can stub the global fetch.
  fetchOptions: { customFetchImpl: (input, init) => fetch(input, init) },
  plugins: [inferAdditionalFields({ user: { kind: { type: "string", input: false } } }), twoFactorClient()],
});

/** Where Better Auth sends a verified address back to (apps/api identity/auth/api.ts agrees). */
export const VERIFIED_CALLBACK = "/login?verified=1";
